import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { useGuest } from '@/context/GuestContext';
import { LoadingPage } from '@/components/ui';

export function ProtectedRoute() {
  const { isSignedIn, isLoaded } = useAuth();
  const { isGuest, isLoaded: guestLoaded } = useGuest();
  const location = useLocation();

  if (!isLoaded || !guestLoaded) {
    return <LoadingPage />;
  }

  if (!isSignedIn && !isGuest) {
    return <Navigate to="/sign-in" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
